import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import RadioFieldDetail from "./detail";
import RadioFieldEdit from "./edit";
import RadioFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type radio en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Radio() {
    return _jsx(_Fragment, { children: "Radio" });
}
var field = fieldsType.radio;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, RadioFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, RadioFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, RadioFieldList);
